import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { DfUiModule } from '@df/ui/df-ui.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';

export interface IlinkListItem {
    link?: string;
    label: string;
    image?: string;
}

export const linkListItem = { link: '', label: 'Default link item label', image: '' };
@Component({
    standalone: true,
    imports: [CommonModule, DfUiModule, ICmsClientModule, HrefComponent, DfModuleImageModule],
    selector: 'link-list1',
    templateUrl: './link-list1.html',
    styleUrls: ['./link-list1.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkList1Component {
    /**
     * Section title
     */
    @Input()
    title?: string;

    /**
     * Links list
     */
    @Input()
    items: IlinkListItem[] = [linkListItem];
}
